let mainVideo = promokit.youtube({
    el:'.p-layer__video',
    youtubeid: 'Z8wgNrIDCQM',
    controls:true,
    mute:false
});

let layerVideo = promokit.layer({
    el: '#layer-video',
    render: true,
    autoplayVideo:mainVideo
});

let layerBox = promokit.layer({
    el: '#layer-box',
    buttons: '.p-btn__box',
});

$(document).on('click', '.p-header__btn-video', function() {
    layerVideo.open();
    // promokit.message({
    //     type: 'alert',
    //     message: '업데이트 영상은 추후 공개됩니다!'
    // });
});

let page = promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'white' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'day', //'year', 'week', 'day'
            key: 'INDEX_WEB_VISIT_200929_sword',
            value: false
        },
        home: true,
        event: true,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    remote: {
        header: '#section-header',
        title: '귀검 & 명도전각',
        home: true, // true, false
        // coupon: true, // true, false
        // nshop: true, // true, false
        active:false, //true, false
        template: `<ul>
                  <li><a href="#section-1">신규 업데이트 안내</a></li>
                  <li><a href="#section-3">사전 이벤트 안내</a></li>
                </ul>`
    }
});


// WEBPACK FOOTER //
// ./src/js/util/common.js